import GameLayout from '~/pages/authentified/GameLayout';
import bg from '@assets/images/background/mode-solo-bg.png';
import { styled } from 'styled-components'; //  keyframes,
import Button from '~/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { Payload, useAuth } from '~/helpers/store/auth';
import { useMutation } from '@apollo/client';
import { GQL_UPDATE_USER } from '~/gql/users/users';
import { authClient } from '~/helpers/apollo';
import { parseJwt } from '~/utils/jwt';
import { useEffect, useState } from 'react';
import RulesBattleDialog from '~/components/game/rules-battle-dialog';
import { WrapperItem } from '~/components/ui/wrapper-item';
import iconBattle from '@assets/images/background/mode-battle.svg';
import { useLingui } from '@lingui/react';
import ButtonText from '~/components/ui/button-text';
import { SDivRules, SSpanTitle } from '~/components/styles/styles';
import { classic } from '~/themes';
import { formatText } from '~/utils/common/utils';
import { RulesItem } from '~/components/ui/rules-item';

function ModeBattlePage() {
  const navigate = useNavigate();
  const { i18n } = useLingui();
  const { payload, setPayload } = useAuth();
  const [isRulesNotSeen, setIsRulesNotSeen] = useState<boolean>(false);
  const [isRulesOpen, setIsRulesOpen] = useState<boolean>(false);

  const [updateUser] = useMutation(GQL_UPDATE_USER, {
    client: authClient,
    variables: {
      updateUserInput: {
        isChallengeable: true,
      },
    },
    onCompleted: (data) => {
      if (data.updateUser.tokens) {
        const dataJwt = parseJwt(data.updateUser.tokens.access_token);
        if (!dataJwt) {
          return;
        }
        const newPayload: Payload = {
          access_token: data.updateUser.tokens.access_token,
          refresh_token: data.updateUser.tokens.refresh_token,
          ...dataJwt,
        };
        setPayload(newPayload);
      }
    },
  });

  useEffect(() => {
    const isRules = localStorage.getItem('epsf-rb');
    if (isRules) {
      setIsRulesNotSeen(false);
    } else {
      setIsRulesNotSeen(true);
    }
  }, []);

  function handleRulesSeen() {
    localStorage.setItem('epsf-rb', '1');
    setIsRulesNotSeen(false);
  }

  function handleRulesClick() {
    setIsRulesOpen(true);
  }

  return (
    <GameLayout
      backgroundSize="cover"
      withoutHeader
      withoutFooter
      background={bg}
    >
      <SDivBlur />
      {payload?.isChallengeable ? (
        <>
          <WrapperItem
            iconSrc={iconBattle}
            widthLandscape="auto"
            widthPortrait="80%"
            customIconWidth="40%"
            customIconHeight="auto"
            customIconTop="-17%"
          >
            <SDivBtn>
              <Button
                margin="10px"
                onClick={() => navigate('/mode-battle/invitations')}
                color={'primary'}
                minHeight="66px"
                minWidth="150px"
              >
                {i18n._('battle.my.challenges')}
              </Button>
              <Button
                margin="10px"
                onClick={() => navigate('/mode-battle/defis')}
                color={'secondary'}
                minHeight="66px"
                minWidth="150px"
              >
                {i18n._('battle.i.challenge')}
              </Button>
            </SDivBtn>

            <SDivBtn>
              <ButtonText
                color="primary"
                type="button"
                onClick={() => navigate('/home')}
                textTransform="uppercase"
              >
                {i18n._('common.back')}
              </ButtonText>
            </SDivBtn>
          </WrapperItem>
        </>
      ) : (
        <>
          <WrapperItem
            iconSrc={iconBattle}
            widthLandscape="auto"
            widthPortrait="80%"
            customIconWidth="40%"
            customIconHeight="auto"
            customIconTop="-17%"
          >
            <SSpanTitle $color={classic.token?.colorText}>
              {formatText(i18n._('battle.is.not.challenge'))}
            </SSpanTitle>
            <SDivBtn>
              <Button
                width="auto"
                minWidth="200px"
                onClick={() =>
                  updateUser({
                    variables: {
                      updateUserInput: {
                        isChallengeable: true,
                      },
                    },
                  })
                }
                color="secondary"
              >
                {i18n._('battle.change.status')}
              </Button>
            </SDivBtn>

            <SDivBtn>
              <ButtonText
                color="primary"
                type="button"
                onClick={() => navigate('/home')}
                textTransform="uppercase"
              >
                {i18n._('common.back')}
              </ButtonText>
            </SDivBtn>
          </WrapperItem>
        </>
      )}

      <SDivRules>
        <RulesItem onClick={handleRulesClick} />
      </SDivRules>
      <RulesBattleDialog
        onClose={() => setIsRulesOpen(false)}
        open={isRulesOpen}
      />

      <RulesBattleDialog onClose={handleRulesSeen} open={isRulesNotSeen} />
    </GameLayout>
  );
}

export default ModeBattlePage;

const SDivBlur = styled.div<{ $background?: boolean }>`
  background: ${({ $background }) =>
    $background
      ? `linear-gradient(180deg, rgba(0, 202, 191, 0.60) 0%, rgba(0, 173, 212, 0.60) 100%)`
      : 'none'};
  backdrop-filter: ${({ $background }) =>
    $background ? `blur(18px)` : 'none'};
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

const SDivBtn = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 10px;
  @media screen and (max-width: 450px) {
    margin: 0;
  }
`;
